import { DropdownOptionType } from "./dropdown-types";

export const removeConsecutiveDividers = (
  arr: DropdownOptionType[],
): DropdownOptionType[] => {
  return arr.reduce<DropdownOptionType[]>((acc, item, index) => {
    if (index === 0 && item.type === "divider") {
      return acc;
    }
    if (index === arr.length - 1 && item.type === "divider") {
      return acc;
    }
    if (
      item.type === "divider" &&
      acc.length > 0 &&
      acc[acc.length - 1].type === "divider"
    ) {
      return acc;
    }
    return [...acc, item];
  }, []);
};
